import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import i18n from "./i18n";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import getLocale from "./common/helpers/getLocale";

interface Props {
  children: ReactElement | ReactElement[];
}

export const LocalizationProviderWrapper = ({ children }: Props) => {
  const { t } = useTranslation();
  const UILanguage = i18n.language;

  const adapterLocale = getLocale();

  const localeText = {
    fieldDayPlaceholder: () => (UILanguage === "fi" ? "pp" : "DD"),
    fieldMonthPlaceholder: () => (UILanguage === "fi" ? "kk" : "MM"),
    fieldYearPlaceholder: () => (UILanguage === "fi" ? "vvvv" : "YYYY"),
    start: t("start", { ns: "common" }) || "",
    end: t("end", { ns: "common" }) || "",
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={adapterLocale}
      localeText={localeText}
      dateFormats={{ fullDate: "dd.MM.yyyy" }}
    >
      {children}
    </LocalizationProvider>
  );
};
